module.exports = __webpack_public_path__ + "static/media/023-calendar.613a88d9.svg";